// src/services/GdriveService.ts
import { BaseService } from "@services/BaseService";

class GdriveService extends BaseService {
  getAuthUrl() {
    return this.get("/gdrive/auth-url");
  }

  getCallback(params: Record<string, string>) {
    return this.get("/gdrive/callback", { params });
  }

  uploadFromDrive(data: any) {
    return this.post("/gdrive/upload-from-drive", data);
  }

  getPickerToken() {
    return this.get("/gdrive/picker-token");
  }

  syncProject(projectId: string) {
    return this.post(`/gdrive/sync/${projectId}`);
  }

  syncFolder(projectId: string, folderId: string) {
    return this.post(`/gdrive/sync/${projectId}/folder/${folderId}`);
  }

  getProjectFolders(projectId: string) {
    return this.get(`/gdrive/${projectId}/folders`);
  }

  getFolderFiles(projectId: string, folderId: string) {
    return this.get(`/gdrive/${projectId}/folders/${folderId}/files`);
  }

  getExternalFiles(projectId: string, offset: number, limit: number) {
    return this.get(`/gdrive/${projectId}/external-files`, {
      params: {
        offset,
        limit,
      },
    });
  }

  deleteFolder(projectId: string, folderId: string) {
    return this.delete(`/gdrive/${projectId}/folders/${folderId}`);
  }
}

export const gdriveService = new GdriveService();
